import { render, staticRenderFns } from "./DurationWrapper.form.vue?vue&type=template&id=ede043ba&scoped=true&"
import script from "./DurationWrapper.form.vue?vue&type=script&lang=js&"
export * from "./DurationWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./DurationWrapper.form.vue?vue&type=style&index=0&id=ede043ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede043ba",
  null
  
)

export default component.exports